import styled from 'styled-components';

const SignUpGeneratePassModalWrapper = styled.div`
  position: relative;
  width: 340px;
  height: 260px;

  .generated-input {
    margin-bottom: 0 !important;
    input {
      cursor: pointer;
    }
  }
  .secure-message {
    line-height: 22px;
  }
  .cancel-button {
    background-color: ${({ theme }) => theme.colors.white[100]};
    border: 1px solid ${({ theme }) => theme.colors.status[20]};
  }
  .copy-button {
    position: relative;
    display: block !important;
  }
  .copy-icon {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
`;

export default SignUpGeneratePassModalWrapper;
